import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Typography,Box } from '@mui/material';
import loaderGif from "./../Assests/loader.gif";
const CommodityFormDialog = ({ open, handleClose, handleSave, initialData }) => {
  const initialFormData = {
    commodity_code_id: '',
    commodity_code: '',
    name: '',
    description: '',
  };

  const [formData, setFormData] = useState(initialFormData);
  const [fieldErrors, setFieldErrors] = useState ({}); // State to track field errors
  const [isSaving, setIsSaving] = useState(false);

  // Handle initial data or reset to initial form data
  useEffect(() => {
    setFieldErrors({});
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData(initialFormData);
    }
  }, [initialData, open]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

// Validate the form fields
const validateForm = () => {
  const errors = {};

  // Check if required fields are filled
  if (!formData.commodity_code) {
    errors.commodity_code = 'Commodity code is required';
  }
  if (!formData.name) {
    errors.name = 'Commodity name is required';
  }

  if (!formData.description) {
    errors.description = 'Description is required';
  }

  setFieldErrors (errors);

  // Return true if no errors
  return Object.keys (errors).length === 0;
};

// Handle the save button click
const onSave = async() => {
  if (validateForm(formData)) {
    setIsSaving(true);
    try{
      await handleSave(formData);
      handleClose();
    }catch(error){
      console.log("error saving commodity code:", error);
    }finally{
      setIsSaving(false);
    }
   
  }
};


  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle className="modal-header">
        {initialData ? 'Update Commodity' : 'Add New Commodity'}
      </DialogTitle>
      {isSaving && (
        <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgcolor="rgba(255, 255, 255, 0.8)"
        zIndex={1}
      >
        <img src={loaderGif} alt="Loading..." width={50} height={50} />
      </Box>
      )}
      <DialogContent>
        <TextField
          margin="dense"
          name="commodity_code"
          label="Commodity Code"
          fullWidth
          variant="outlined"
          value={formData.commodity_code}
          onChange={handleChange}
          disabled={!!initialData} 
        />
         {fieldErrors.commodity_code &&
          <div style={{color: 'red', fontSize: '0.875rem'}}>
            {fieldErrors.commodity_code}
          </div>}        
        <TextField
          margin="dense"
          name="name"
          label="Commodity Name"
          fullWidth
          variant="outlined"
          value={formData.name}
          onChange={handleChange}
        />
         {fieldErrors.name &&
          <div style={{color: 'red', fontSize: '0.875rem'}}>
            {fieldErrors.name}
          </div>}        
        <TextField
          margin="dense"
          name="description"
          label="Description"
          fullWidth
          variant="outlined"
          value={formData.description}
          onChange={handleChange}
        />
         {fieldErrors.description &&
          <div style={{color: 'red', fontSize: '0.875rem'}}>
            {fieldErrors.description}
          </div>}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onSave} color="primary" variant="contained">
          {initialData ? 'Update' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommodityFormDialog;
